import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NavBarAction, NavbarItem } from '@timechef/core/models/app';

@Component({
  selector: 'app-menu-popover',
  templateUrl: './menu-popover.component.html',
  styleUrls: ['./menu-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MenuPopoverComponent {
  @Input() items: NavbarItem[] = [];
  @Input() onItemClick?: (action: NavBarAction) => void;

  constructor(private popover: PopoverController) {}

  async click(event: any, item: NavbarItem) {
    if (this.onItemClick && item.action) {
      event.stopPropagation();
      event.preventDefault();
      this.onItemClick(item.action);
    }
    await this.popover.dismiss();
  }
}
